import React, { Component, Fragment } from 'react'
import styles from './style.module.less'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Spin, Tooltip } from 'hljd'
import store from './store'
import { observer } from 'mobx-react'
import BankCardPay from './BankCardPay'
import WeixinPay from './WeixinPay'

const RadioGroup = Radio.Group

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const { location = {}, outsideQuery } = this.props
    store.initParams(location.query || outsideQuery)
  }

  componentDidMount() {
    store.getWithdraw()
  }

  render() {
    const radioStyle = {
      display: 'block',
      padding: '20px 16px',
      borderBottom: '1px solid #E2E2E2'
    }

    const {
      payType,
      cant,
      price,
      title,
      checkApi,
      walletShow,
      loading,
      productCoupon,
      orderPrice,
      serviceTime,
      isUltimate
    } = store
    let cantArray = (cant || '').split(',') || []
    const { coupon_name, coupon_type, money_value, money_sill, gift_day } =
      productCoupon || {}
    let discountTxt = ''
    if (coupon_type == 3) {
      discountTxt = <span>{`${coupon_name}：赠送${gift_day || 0}天`}</span>
    } else {
      discountTxt = (
        <span>{`${coupon_name}：${
          coupon_type == 1 ? `满${money_sill || 0}` : ''
        }减${money_value || 0}`}</span>
      )
    }
    return (
      <div className={styles.wrapper} style={{ height: 'auto' }}>
        <Spin spinning={loading}>
          {/*<div className={styles.title}>收银台</div>*/}
          <div className={styles.inner}>
            <p>订单类型：{title}</p>
            {serviceTime && <p>服务期限：{serviceTime}年</p>}
            <p className={styles.p2}>
              产品价格：<span>{orderPrice}</span>元
            </p>
            {isUltimate() &&
              coupon_type && (
                <p>
                  活动优惠<Tooltip placement="bottom" title={discountTxt}>
                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                  </Tooltip>：{coupon_type == 3 ? (
                    <Fragment>
                      <span className={styles.bold}>+{gift_day}</span>天
                    </Fragment>
                  ) : (
                    <Fragment>
                      <span className={styles.bold}>-{money_value}</span>元
                    </Fragment>
                  )}
                </p>
              )}
            <RadioGroup onChange={store.changePayType} value={payType}>
              <Radio
                style={radioStyle}
                value={1}
                disabled={cantArray.indexOf('1') > -1 || walletShow}
              >
                <img src="https://qnm.hunliji.com/FvtshDaIzVKacGvNjSWSjBFjZHJ9" />

                <span className={styles.name}>余额支付</span>
                {payType == 1 && (
                  <span className={styles.desc}>
                    支付<span>{price}</span>元
                  </span>
                )}
                {cantArray.indexOf('1') > -1 && (
                  <span className={styles.cant}>
                    该付款方式暂不支持当前交易
                  </span>
                )}
                {walletShow && <span className={styles.cant}>金额不足</span>}
              </Radio>
              <Radio
                style={radioStyle}
                value={2}
                disabled={cantArray.indexOf('2') > -1 || Number(price) <= 0}
              >
                <img src="https://qnm.hunliji.com/FgUWoi4Al5zRYSmhhChXryAbCHOl" />
                <span className={styles.name}>支付宝支付</span>
                {payType == 2 && (
                  <span className={styles.desc}>
                    支付<span>{price}</span>元
                  </span>
                )}
                {cantArray.indexOf('2') > -1 && (
                  <span className={styles.cant}>
                    该付款方式暂不支持当前交易
                  </span>
                )}
              </Radio>
              <Radio
                style={radioStyle}
                value={3}
                disabled={cantArray.indexOf('3') > -1 || Number(price) <= 0}
              >
                <img src="https://qnm.hunliji.com/Fr0fPHFLIpFHFk0r7wjH7agPjF2F" />
                <span className={styles.name}>微信支付</span>
                {payType == 3 && (
                  <span className={styles.desc}>
                    支付<span>{price}</span>元
                  </span>
                )}
                {cantArray.indexOf('3') > -1 && (
                  <span className={styles.cant}>
                    该付款方式暂不支持当前交易
                  </span>
                )}
              </Radio>
              {/* <Radio
                style={radioStyle}
                value={4}
                disabled={cantArray.indexOf('4') > -1 || Number(price) <= 0}
              >
                <img src="http://qnm.hunliji.com/o_1boucjbkfcfa4uhi2n1f2g9add.png" />
                <span className={styles.name}>银行卡支付</span>
                {payType == 4 && (
                  <span className={styles.desc}>
                    支付<span>{price}</span>元
                  </span>
                )}
                {cantArray.indexOf('4') > -1 && (
                  <span className={styles.cant}>
                    该付款方式暂不支持当前交易
                  </span>
                )}
              </Radio> */}
            </RadioGroup>
          </div>
          <div className={styles.paybtn} onClick={store.toPay}>
            确认支付
          </div>
        </Spin>

        <BankCardPay />
        <WeixinPay money={price} checkApi={checkApi} />
      </div>
    )
  }
}
